import { render, staticRenderFns } from "./HelpSiteLink.vue?vue&type=template&id=08b7ef75&scoped=true"
import script from "./HelpSiteLink.vue?vue&type=script&lang=ts"
export * from "./HelpSiteLink.vue?vue&type=script&lang=ts"
import style0 from "./HelpSiteLink.vue?vue&type=style&index=0&id=08b7ef75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b7ef75",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/home-menu/help-site-link.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fhome-menu%2FHelpSiteLink.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports